/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum Rag {
  Red = 'Red',
  Amber = 'Amber',
  Green = 'Green'
}
